import { render, staticRenderFns } from "./BlankLayout.vue?vue&type=template&id=31051a2e&scoped=true"
import script from "./BlankLayout.vue?vue&type=script&lang=js"
export * from "./BlankLayout.vue?vue&type=script&lang=js"
import style0 from "./BlankLayout.vue?vue&type=style&index=0&id=31051a2e&prod&lang=css"
import style1 from "./BlankLayout.vue?vue&type=style&index=1&id=31051a2e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31051a2e",
  null
  
)

export default component.exports